module.exports = __webpack_public_path__ + "img/arrow-chevron-left.svg";